import { Routes } from '@angular/router';
import { knightmedsInstanceGuard } from '../guards/knightmeds-instance.guard';
import { ReloadPagesComponent } from './reload-pages.component';
import { ContainersPageComponent } from './pages/containers-page/containers-page.component';
import { ReloadPageComponent } from './pages/reload-page/reload-page.component';
import { PATH_RELOAD_PAGES, PATH_CONTAINERS, PATH_RELOAD, PATH_CONTAINER_ID } from 'src/app/global';

export const reloadPagesRoutes: Routes = [
  {
    path: PATH_RELOAD_PAGES,
    component: ReloadPagesComponent,
    canActivate: [knightmedsInstanceGuard],
    children: [
      { path: '', redirectTo: PATH_CONTAINERS, pathMatch: 'full' },
      {
        path: PATH_CONTAINERS,
        component: ContainersPageComponent,
      },
      {
        path: `${PATH_RELOAD}/:${PATH_CONTAINER_ID}`,
        component: ReloadPageComponent,
      },
    ],
  },
];
